module.exports = __webpack_public_path__ + "img/ch08_02_糖糖接待.7bd5b793.jpg";